<template>
  <div>
    <template v-if="hasCompressEvidenceUiPermission()">
      <el-button style="margin-top: 9px;"
                 v-if="showCompressBtn()"
                 size="mini"
                 type="warning"
                 @click="onCompressEvidence(orderDetail)">
        工单证据找回
      </el-button>
      <el-button style="margin-top: 9px;"
                 size="mini"
                 v-if="immTaskStatus === 'running'"
                 @click="showRunProgress()"
                 type="primary">
        <i class="el-icon-loading"></i>
        工单证据找回中
      </el-button>
      <el-button style="margin-top: 9px;"
                 v-if="showDownloadBtn()"
                 size="mini"
                 type="success"
                 @click="downloadZip()">
        下载已找回的工单证据
      </el-button>
    </template>
  </div>
</template>

<script>
import { getOrderLatestCompressDetailApi } from '@views/order/order.api'

export default {
  components: {},
  mixins: [],
  props: {
    orderDetail: Object,
    components: Object,
  },
  data () {
    return {
      immTask: null,
      immTaskStatus: '',
    }
  },
  computed: {},
  watch: {
    orderDetail: {
      async handler (newVal) {
        if (newVal && newVal.orderid > 0) {
          if (this.hasCompressEvidenceUiPermission()) {
            try {
              const {data} = await getOrderLatestCompressDetailApi({orderid: this.orderDetail.orderid})
              this.immTask = data.detail
              this.immTaskStatus = _.get(this.immTask, 'status', '').toLowerCase()
            } catch (e) {
              console.error('获取imm压缩任务数据失败', e)
            }
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    async onCompressEvidence () {
      let orderid = this.orderDetail.orderid
      if (orderid) {
        let msg = ''
        if (this.immTaskStatus === 'failed') {
          msg += `上一个找回任务已发生错误,错误原因:【${this.immTask.err_msg}】,`
        }
        msg += '您确定要找回当前工单的证据资料吗？'

        await this.$confirm(msg)
        await request.alert('createOrderEvidenceCompressTaskApi', {orderid})
        this.$message({
          showClose: true,
          message: '操作成功',
          type: 'success',
        })
        this.$store.dispatch('setOrderDetail', {id: orderid})
      }
    },
    showRunProgress () {
      this.$alert('工单找回中,请稍后手动刷新页面查看任务进度')
    },
    showCompressBtn () {
      if (this.immTaskStatus === 'running') {
        return false
      }
      if (this.immTaskStatus === 'succeeded') {
        return moment().isAfter(this.immTask.zip_expire_at)
      }
      return true
    },
    showDownloadBtn () {
      if (this.immTaskStatus !== 'succeeded') {
        return false
      }
      return moment().isBefore(this.immTask.zip_expire_at)
    },
    hasCompressEvidenceUiPermission () {
      // UI权限目录: 任务管理 - 工单证据找回
      return filter.hasPermission(287)
    },
    downloadZip () {
      window.open(this.immTask.zip_path)
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/OrderCompressEvidenceButton.vue